export function preventReimport(parentModule: unknown, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import it only once.`);
  }
}
